const addToCartForm = document.querySelector('.js-product-form')
const sellingPlan = addToCartForm.querySelector('.js-selling-plan').value

if (sellingPlan != '') {
    // Disable All Select Options
    for( const select of addToCartForm.querySelectorAll('select')) {
        select.disabled = true
    }
    
    // Disable All Input Options
    for( const input of addToCartForm.querySelectorAll('input')) {
        input.disabled = true
    }

    // Disable ATC Button
    const atcButton = addToCartForm.querySelector('#AddToCart')
    atcButton.style.pointerEvents = 'none'

    const observerOptions = {
        childList: true,
        attributes: true,
        subtree: true
    }
      
    const observer = new MutationObserver(mutations => {
        mutations.forEach(record => {
            if(record.type === "attributes") {
                if (record.target.classList.contains('rc-container-wrapper')) {
                    // Enable All Select Options
                    for( const select of addToCartForm.querySelectorAll('select')) {
                        select.disabled = false
                    }
                    
                    // Enable All Input Options
                    for( const input of addToCartForm.querySelectorAll('input')) {
                        input.disabled = false
                    }

                    // Enable ATC Button
                    const atcButton = addToCartForm.querySelector('#AddToCart')
                    atcButton.style.pointerEvents = 'unset'
                }
            }
        });
    });
    observer.observe(addToCartForm, observerOptions);
}

